<template>
    <div class="view view--add-wallpaper-category">
        <edit-wallpaper-category />
    </div>
</template>

<script>
    import editWallpaperCategory from '../../../components/EditWallpaperCategory.vue';

    export default {
        components: {
            editWallpaperCategory
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/wallpapers/categories/Add.vue